import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_snap_icon = _resolveComponent("snap-icon")!
  const _component_snap_button = _resolveComponent("snap-button")!
  const _component_snap_modal = _resolveComponent("snap-modal")!

  return _withDirectives((_openBlock(), _createBlock(_component_snap_modal, {
    onSnapModalClose: _ctx.close,
    _title: _ctx.title,
    prompt: ""
  }, {
    default: _withCtx(() => [
      (_ctx.type == 'warning')
        ? (_openBlock(), _createBlock(_component_snap_icon, {
            key: 0,
            icon: "exclamation-solid",
            color: "#D97706",
            size: "md",
            state: "rounded",
            "bg-color": "#FEF3C7"
          }))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default"),
      (_ctx.wideCloseButton)
        ? (_openBlock(), _createBlock(_component_snap_button, {
            key: 1,
            onClick: _ctx.close,
            "full-width": "",
            size: "md",
            variant: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Continue")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["onSnapModalClose", "_title"])), [
    [_vShow, _ctx.isOpened]
  ])
}